import { useState } from 'react'
import { shopOption, FilterIcon, max_price, min_price } from '../../base'
import { useSelector } from 'react-redux'

function SearchProductFilter({ filter, setFilter, clearFilter, dispatch, changeSearchedProductsFilter }) {
    const [filterName, setFilterName] = useState('shop')
    const category_options = useSelector((state)=>state.appSlice.category_options) 

    function changeFilter(e) {
        const { name, value, checked } = e.target
        setFilter((prev) => {
            return {
                ...prev,
                [name]: name === 'shop' || name === 'category' ? checked ? [...prev[name], value] : prev[name].filter(item => item !== value) : value
            }
        })
    }

    function priceChange(e) {
        const { name, value } = e.target
        console.log(name, value, value > filter['price__gte'])
        if (name === 'price__gte' && value < filter['price__lte']) {
            changeFilter(e)
        }
        else if (name === 'price__lte' && value > filter['price__gte']) {
            changeFilter(e)
        }

    }

    return (
        <div className='productFilter'>
            <div className='d-none d-sm-flex refine' data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop"><span><FilterIcon /></span>Filter</div>


            <div className="offcanvas offcanvas-top" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title h5 heading" id="offcanvasTopLabel">Apply Filters and Sort result </h5>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body ps-1 pe-1 pt-0 ps-sm-4 pe-sm-4" style={{overflowX : 'hidden'}}>
                    <div className='row' style={{justifyContent : 'center'}}>
                        <div className='col-md-3 col-lg-2'>
                            <div className='filterTab flex-md-column flex-row mb-3'>
                                <div className={`h6 ${filterName === 'shop' ? 'active' : ''}`} onClick={() => setFilterName('shop')}>Shop</div>
                                <div className={`h6 ${filterName === 'category' ? 'active' : ''}`} onClick={() => setFilterName('category')}>Category</div>
                                <div className={`h6 ${filterName === 'availability' ? 'active' : ''}`} onClick={() => setFilterName('availability')}>Availability</div>
                                <div className={`h6 ${filterName === 'price' ? 'active' : ''}`} onClick={() => setFilterName('price')}>Price</div>
                            </div>
                        </div>
                        <div className='col-md-9 col-lg-7 mb-3'>
                            <div className={`filterOption  ${filterName === 'shop' ? 'd-flex row' : 'd-none'}`}>
                                {
                                    shopOption.map((item, index) => {
                                        return item !== 'all' && (
                                            <div className='col-12 col-sm-6' key={index}>
                                                <label style={{ fontSize: '15px' }} key={index}><input type='checkbox' value={item} checked={filter.shop.includes(item)} onChange={(e) => changeFilter(e)} name='shop' />{item}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={`filterOption ${filterName === 'category' ? 'd-flex row' : 'd-none'}`}>
                                {
                                    category_options && category_options.map((item, index) => {
                                        return item !== 'all' && (
                                            <div className='col-6' key={index}>
                                                <label style={{ fontSize: '15px' }} key={index}><input type='checkbox' value={item} checked={filter.category.includes(item)} onChange={(e) => changeFilter(e)} name='category' />{item}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={`filterOption flex-column ${filterName === 'availability' ? 'd-flex' : 'd-none'}`} style={{ maxWidth: '300px', margin: 'auto' }}>
                                <label><input type='radio' name='availability' value={'all'} checked={filter.availability === 'all'} onChange={(e) => changeFilter(e)}></input>All</label>
                                <label><input type='radio' name='availability' value={'in-stock'} checked={filter.availability === 'in-stock'} onChange={(e) => changeFilter(e)}></input>In Stock</label>
                                <label><input type='radio' name='availability' value={'out-of-stock'} checked={filter.availability === 'out-of-stock'} onChange={(e) => changeFilter(e)}></input>Out Of Stock</label>
                            </div>
                            <div className={`filterOption flex-column w-75 ${filterName === 'price' ? 'd-flex' : 'd-none'}`} style={{ maxWidth: '400px', margin: 'auto' }}>
                                <label>Lower Price : {filter.price__gte}</label>
                                <input type='range' name='price__gte' step={500} min={min_price} max={max_price} value={filter.price__gte} onChange={(e) => priceChange(e)} />
                                <label>Higher Price : {filter.price__lte}</label>
                                <input type='range' name='price__lte' step={500} min={min_price} max={max_price} value={filter.price__lte} onChange={(e) => priceChange(e)} />
                            </div>
                        </div>
                        <div className='col-11 col-md-5 col-lg-3'>
                            <label>Sort / Order By</label>
                            <select value={filter.sort_by} name='sort_by' onChange={(e) => changeFilter(e)}>
                                <option value={'-added_on'}>Date, New to Old</option>
                                <option value={'added_on'}>Date, Old to New</option>
                                <option value={'-price'}>Price, High to Low</option>
                                <option value={'price'}>Price, Low to High</option>
                                <option value={'-discount'}>Discount, High to Low</option>
                                <option value={'discount'}>Discount, Low to High</option>
                                <option value={'-unit_sold'}>Top Selling</option>
                            </select>
                            <div className='d-flex mt-4 justify-content-between flex-row flex-lg-column'>
                                <button className='secondryButton h6 ms-1 me-1' onClick={() => clearFilter()}>Clear All Filter</button>
                                <button className='secondryButton h6 ms-1 me-1 mb-lg-3' data-bs-dismiss="offcanvas" aria-label="Close" onClick={() =>dispatch(changeSearchedProductsFilter({ 'filter' : filter, change: 'filter' }))}>Get Products</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchProductFilter